import styled from "styled-components";
import { MOBILE, LARGE, EXTRA_LARGE } from "@minerva-analytics/pantheon";
import {
  BACKGROUND_COLOR,
  BODY_TEXT_COLOR,
  GRAY_LEGAL_BODY,
  GRAY_LEGAL_HEADER,
  PRIMARY_FONT_TEXT,
  SECONDARY_COLOR,
  TERTIARY_BACKGROUND_COLOR,
  TITLE_FONT,
} from "../../theme";

export const LegalContainer = styled.div`
  width: 70%;
  margin: 0 auto;
  padding-bottom: 1rem;
  background-color: ${BACKGROUND_COLOR};
  @media (max-width: ${LARGE}) {
    width: 80%;
  }
  @media (max-width: ${MOBILE}) {
    width: 90%;
  }
  h1 {
    font-family: ${TITLE_FONT};
    color: ${BODY_TEXT_COLOR};
  }
  h2 {
    font-family: ${PRIMARY_FONT_TEXT};
    font-weight: 600;
    color: ${GRAY_LEGAL_HEADER};
  }
  h3 {
    font-family: ${PRIMARY_FONT_TEXT};
    color: ${GRAY_LEGAL_HEADER};
    font-weight: 400;
  }

  p,
  li {
    font-family: ${PRIMARY_FONT_TEXT};
    font-weight: normal;
    color: ${GRAY_LEGAL_BODY};
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 0.6px;
  }

  a {
    color: ${SECONDARY_COLOR};
  }
`;

export const Background = styled.div`
  background-color: ${BACKGROUND_COLOR};
  @media (min-width: ${EXTRA_LARGE}) {
    position: fixed;
    top: 0px;
    height: 375%;
    right: 0px;
    width: 100%;
  }
  z-index: -1;
`;

export const LegalCard = styled.div`
  border-top: 1rem solid ${TERTIARY_BACKGROUND_COLOR};
  background-color: ${BACKGROUND_COLOR};
  padding: 1rem 2.5rem;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 10px 0px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
`;
